import s from "./ui.module.css";

/** Wortmarke „obsn*“: Stern unten rechts an der Grundlinie, nicht hochgestellt (Brand Board Okt. 2026, wie `.ast` auf obsn.de). */
export function Wortmarke() {
  return (
    <span className={s.wortmarke}>
      obsn
      <span className={s.wortmarkeStern} aria-hidden="true">
        *
      </span>
    </span>
  );
}
